module.exports = __webpack_public_path__ + "img/32.05d19179.jpg";